import { combineReducers } from "redux";
import userInfoReducer from "./authReducer";
import projectReducer from "./projectReducers";
import defaultSettingsReducer from "./defaultSettingsReducers";
import projectsReducer from "./projectsReducer";
import undoRedoReducer from "./undoRedoReducer";
import applicationReducer from "./applicationReducer";
import commonReducer from "./commonReducer";
import HelpingPageReducer from "./HelpingPageReducer";

const reducers = combineReducers({
  userInfo: userInfoReducer,
  project: projectReducer,
  defaultSettings: defaultSettingsReducer,
  projects: projectsReducer,
  undoRedo: undoRedoReducer,
  application: applicationReducer,
  commonReducer:commonReducer,
  HelpingPageReducer:HelpingPageReducer
});

export default reducers;